import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { preloadCriticalResources } from './utils/cache'
import { initCriticalOptimizations } from './utils/criticalCSS'
import { initPerformanceOptimizations, addResourceHints } from './utils/performance'

// Inyectar CSS crítico inmediatamente (antes de React)
initCriticalOptimizations();

// Añadir Resource Hints
addResourceHints();

// Precargar recursos críticos en segundo plano
if ('caches' in window) {
  preloadCriticalResources().catch(console.error);
}

// Inicializar optimizaciones de performance
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPerformanceOptimizations);
} else {
  initPerformanceOptimizations();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
